import React from 'react';
import Table from 'components/Table';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { IconButton, Box } from '@mui/material';
import { TABLE_HEADERS } from 'constants';

const EditorDebtItem = ({ data, onDelete, onChange }) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <Table
        headers={TABLE_HEADERS}
        rows={[
          { id: 1, field: 'Debt Profile', value: data.debtProfile },
          { id: 2, field: 'Period (year)', value: data.year },
        ]}
        onChange={onChange}
        parentId={data.id}
      />

      <Box sx={{ display: 'flex', alignSelf: 'flex-start' }}>
        <IconButton onClick={onDelete}>
          <DeleteForeverIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
export default EditorDebtItem;
